export const itunesLink =
  "https://apps.apple.com/us/app/pumpal/id1454740845"
export const googlePlayLink =
  "https://play.google.com/store/apps/details?id=com.getpumpal.app"
